<template>
  <v-container class="app-page-container">
			<v-card class="shadow-none app-page-card" v-if="user">
                  <v-card-title>
                    <v-flex xs6>
                        Questionaires
                    </v-flex>
                  </v-card-title>
                <v-card-text class = "leaderboard">
                    <v-layout row wrap class="leaderboard__head">
                      <v-flex xs3> 
                      </v-flex>
                      <v-flex xs5> 
                        name
                      </v-flex>
                      <v-flex xs1> 
                        lang
                      </v-flex>
                      <v-flex xs2> 
                        created at
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-for="(que, index) in queList" :key="index" class="leaderboard__row"> 
                      <v-flex xs1></v-flex> 
                      <v-flex xs2> 
                          <div v-if="$store.getters.isAdmin">
                              <v-icon @click="editQuestionaire(que.id)">mdi-pencil</v-icon>
                              <v-icon @click="deleteQuestionaire(que.id)">mdi-delete</v-icon>
                              <v-icon @click="showGroups = index; feedback = null">mdi-chat</v-icon>
                          </div>
                      </v-flex>
                      <v-flex xs5 @click="editQuestionaire(que.id)" > 
                          <div>
                              {{que.content}}
                          </div>
                      </v-flex>

                      <v-flex xs1 @click="editQuestionaire(que.id)" > 
                        {{que.lang_id}}
                      </v-flex>                

                      <v-flex xs2 @click="editQuestionaire(que.id)"> 
                        {{que.created_at}}
                      </v-flex>
                      <v-flex xs1> </v-flex>
                      <v-flex xs1> </v-flex>
                      <v-flex xs10>
                        <v-card v-if="showGroups == index && groupList">
                          <v-icon class="btn-close" @click="showGroups = -1; feedback = null;">close</v-icon>  
                          <v-card-title>
                            Send to selected groups
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs6>                          
                                <v-autocomplete
                                      v-model="selected_groups"
                                      :items="groupList"
                                      item-text="name"
                                      item-value="id"
                                      label="Select groups"
                                      clearable
                                      multiple                        
                                      small-chips         
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs6>                          
                                <v-autocomplete
                                      v-model="selected_courses"
                                      :items="courseList"
                                      item-text="name"
                                      item-value="id"
                                      label="Select courses (one course = one questionnaire)"
                                      clearable
                                      small-chips         
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs1></v-flex>
                              <v-flex xs12>
                                <p v-if="feedback">{{feedback}}</p>
                                <v-btn dense @click="sendQuestionaire(que.id)">Send to users in selected groups</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs1> </v-flex>

                    </v-layout>
                </v-card-text>
                <v-card-text>
                  <v-layout justify-center>
                          <v-icon size="medium" @click="editQuestionaire(0)">mdi-plus-circle-outline</v-icon> 
                  </v-layout>
                </v-card-text>
      </v-card>
	</v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    data() {
      return {
        queList: null,
        groupList: null,
        selected_groups: [],
        courseList: null,
        selected_courses: [],
        showGroups: -1,
        feedback: null,
      }
    },
    mounted () {
      this.initData()
   },
   computed: 
      mapGetters([
                      'user'
                  ])
   ,
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'Questionnaires', href: '/que_list'}])//#
      this.getQuestionaires()
    },
    getQuestionaires() {
      axios.get('/get-questionaires', this.$store.getters.getAxiosConfig)
        .then(res => {
          // set data to store
          this.queList = res.data.list
          axios.get('/get-leaders-filter-data', this.$store.getters.getAxiosConfig)
            .then(res => {
              this.courseList = res.data.courses
              this.groupList = res.data.groups           
        /*         /get-teaching-groups', this.$store.getters.getAxiosConfig)
                    .then(res => {
                        // set data to store
                        this.groupList = res.data.teach_groups
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)          
                    })
                  axios.get('/get-all-courses', this.$store.getters.getAxiosConfig)
                    .then(res => {
                        // set data to store
                        this.courseList = res.data.courses
                    })
     */         })
              .catch(error => {
                  this.$store.commit('setFeedback', error)          
              })
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    editQuestionaire(id) {
        this.$router.push({name:'questionnaire', params: {id: id}})        
    },
    deleteQuestionaire(id) {
        this.$router.push({name:'questionnaire', params: {id: id}})        
    },
    sendQuestionaire(id) {
      var _course_list = ''
      if (this.selected_courses != '')
        _course_list = "" + this.selected_courses
      const data = {
        group_list: this.selected_groups.toString(),
        course_list: _course_list,
        questionnaire_id: id
      }
      axios.post('/send-questionnaire', data, this.$store.getters.getAxiosConfig)
        .then((res) => {
            this.feedback = res.data.message
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    }

   }
  }
</script>

<style>

</style>